<template>
    <div class="users-style" >
        
        <b-form-checkbox v-model="allow_outside" class="strong" @change="setallowOutsideCloking(n)">Allow clocking in/out outside of the assigned Geo location</b-form-checkbox>

        <div class="my-4 ">Assigned Geo Locations</div>
        <ul class="list-group">
            <li v-for="(location , n) in locations" :key="n" class="list-group-item">                    
                <b-form-checkbox v-model="location_mappings[n]" @change="assignLocation(n)" >{{locations[n]}}</b-form-checkbox>
            </li>
        </ul>        
    </div>
</template>

<script>
    export default{
        
        mounted() {
           
        },
        props: [],
        data(){            
            
            return {
                
                locations : [],
                location_mappings : [],

                allow_outside : false,
                                
            }
        },
        methods:{
            getallowOutsideCloking :function(){

                
                let currentObj = this;

                axios.get(this.$api_url+'/geolocation/outsideclock')
                    .then(function (response) {
                        this.allow_outside = response.data;
                            
                    }.bind(this));

            },
            setallowOutsideCloking :function(){
                let currentObj = this;

                let formData = new FormData();
                
                if(this.allow_outside)
                    formData.append('flg', 1);
                else
                    formData.append('flg', 0);

                axios.post(this.$api_url+'/geolocation/outsideclock', formData)
                            .then(function (response) 
                            {
                                
                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });

                                
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.serverError(error);
                                currentObj.errormsg = error.response.data.errors;                                    
                            });
            },


            assignLocation :function(location_id)
            {
                let flg = 1;

                if(this.location_mappings[location_id]) flg = 0;
                
                let currentObj = this;
                
                let formData = new FormData();                    
                formData.append('location_id', location_id);
                formData.append('flg', flg);

                axios.post(this.$api_url+'/geolocation/mapemployee', formData)
                            .then(function (response) 
                            {
                                                    
                                this.getLocationMapping();
                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });

                                
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.serverError(error);
                                currentObj.errormsg = error.response.data.errors;                                    
                            });
            },
            getLocationMapping: function(){
              axios.get(this.$api_url+'/geolocation/mapemployee')
              .then(function (response) {
                    this.locations = response.data.geolocations;
                    

                    if(response.data.mapping.length > 0)
                    {
                        
                        var x = response.data.mapping;

                        x.forEach(element => {
                            this.location_mappings[element] = true;
                        });

                    }
                    
              }.bind(this));
         
            },

        },
        created: function(){

            this.getallowOutsideCloking();
            this.getLocationMapping();
            
            
        },
    }
</script>
